import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export const HeadingArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const DiagramWrapper = styled.div`
  width: 100%;
  margin-top: 64px;

  > svg {
    display: block;
    height: auto;
    margin: 0 auto;
    max-width: 1100px;
  }

  @media screen and (min-width: ${themeGet('breakpoints.2')}) {
    margin-top: 80px;
  }
`

export const Strong = styled.strong`
  font-weight: ${themeGet('fontWeights.1')};
`

// The diagram's ~37 labels are baked into the SVG as path outlines, so they
// reach a reader perfectly and a crawler not at all. This restates them as
// real text, which is also what fills the space the SVG leaves under itself.
export const CapabilityGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${themeGet('space.9')}px;
  width: 100%;
  max-width: 1100px;
  margin: 64px auto 0 auto;

  @media screen and (min-width: ${themeGet('breakpoints.1')}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: ${themeGet('breakpoints.3')}) {
    grid-template-columns: repeat(4, 1fr);
    gap: ${themeGet('space.11')}px;
  }
`

export const CapabilityGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${themeGet('space.3')}px;
  min-width: 0;
`
